var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-view',{attrs:{"is-mobile":this.isMobile,"theme":this.theme}})}
var staticRenderFns = []

export { render, staticRenderFns }